module.exports = __webpack_public_path__ + "static/media/logo_vetsion.881652c1.svg";